"use client";

import { Alert } from "@urbansportsclub/components/Alert";
import { AlertContent } from "@urbansportsclub/components/Alert/Content";
import { AlertTitle } from "@urbansportsclub/components/Alert/Title";
import { sendEvent, uppercaseFirstChar } from "@/lib/utils";
import { useEffect } from "react";
import { EVENTS } from "@/constants/tracking";

interface ITokenValidation {
  error: { message: string; title: string } | null;
}

export default function TokenValidation({ error }: Readonly<ITokenValidation>) {
  useEffect(() => {
    if (error) {
      sendEvent({
        event: EVENTS.actionFailed,
        error_message: error.message,
        details: "URL Token Validation",
        origin: "B2E Activation",
      });
    }
  }, [error]);

  if (!error) {
    return <></>;
  }

  return (
    <Alert severity="error" className="mt-10">
      <AlertTitle>{error.title}</AlertTitle>
      <AlertContent>{uppercaseFirstChar(error.message)}</AlertContent>
    </Alert>
  );
}
